import React from 'react';

import { duplicateCampaign } from 'scenes/Campaigns/GGCampaigns/components/CampaignForm/schema';
import { useLoadCampaign } from 'scenes/Campaigns/GGCampaigns/data';
import { useMoveToAnotherAffiliate } from 'scenes/Campaigns/GGCampaigns/data/mutations';
import { TEST_CAMPAIGN_ID } from 'scenes/Campaigns/components/Form/constants';

import MoveToAnotherAffiliateForm from './MoveToAnotherAffiliateForm';

export const MoveToAnotherAffiliate = ({ id, onSubmit, ...props }) => {
  const [moveToAnotherAffiliate, { isLoading: isCreating }] =
    useMoveToAnotherAffiliate();
  const { data, isLoading } = useLoadCampaign({ id });

  const {
    /* eslint-disable */
    partnerCampaignIdCreatedDate,
    partnerCampaignIdCreator,
    /* eslint-enable */
    ...campaign
  } = data || {};

  if (data) {
    campaign[TEST_CAMPAIGN_ID] = id;
  }

  const handleSubmit = (values) => {
    moveToAnotherAffiliate(values).then(onSubmit);
  };

  return (
    <MoveToAnotherAffiliateForm
      loading={isLoading || isCreating}
      onSubmit={handleSubmit}
      active={!!data}
      initialValues={data && duplicateCampaign(campaign)}
      {...props}
    />
  );
};
